export const BASE_IMAGE_URL = "https://app.supabase.com/project/cjirbrmasqghxypuhlcb/storage/buckets/premisesimages/"
export const SUPABASE_PREMISES_BUCKET = "premisesimages"
export const PUBLIC_PREMISESIMAGES_URL = "https://cjirbrmasqghxypuhlcb.supabase.co/storage/v1/object/public/premisesimages/"
export const PREMISES_TABLE = "Premises"